module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-base-info-form"
  }, [_c('h4', [_vm._v("公司基本信息\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.getTsInfoLoading
    },
    on: {
      "click": _vm.getTsInfo
    }
  }, [_vm._v(_vm._s(_vm.getAndHcLabel))])], 1)]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.companyInfo,
      "label-width": "84px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }]
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    on: {
      "blur": _vm.companyblur,
      "focus": _vm.companyFocus
    },
    model: {
      value: (_vm.companyInfo.CustomerName),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "CustomerName", $$v)
      },
      expression: "companyInfo.CustomerName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属招商经理",
      "required": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.selectStaffFn('Manager')
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.LeasingManagerName))])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属业务经理",
      "required": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.selectStaffFn('Employee')
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.companyInfo.BusEmployeeName))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.SocialCreditCode),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "SocialCreditCode", $$v)
      },
      expression: "companyInfo.SocialCreditCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司法定代表人",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.Corporation),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Corporation", $$v)
      },
      expression: "companyInfo.Corporation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证",
      "required": _vm.isRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Corporation_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showImgOpt),
        expression: "showImgOpt"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.companyInfo.Corporation_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgOpt),
      expression: "showImgOpt"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.crpdContainerId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.crpdBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业执照",
      "required": _vm.isRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Company_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showImgOpt),
        expression: "showImgOpt"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.companyInfo.Company_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgOpt),
      expression: "showImgOpt"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.cdContainerId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.cdBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系地址",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择省",
      "filterable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selfChangeProvince
    },
    model: {
      value: (_vm.companyInfo.ProvId),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "ProvId", $$v)
      },
      expression: "companyInfo.ProvId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择市",
      "filterable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selfChangeCity
    },
    model: {
      value: (_vm.companyInfo.CityId),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "CityId", $$v)
      },
      expression: "companyInfo.CityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "widthLen",
    attrs: {
      "placeholder": "选择区",
      "filterable": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.companyInfo.AreaId),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "AreaId", $$v)
      },
      expression: "companyInfo.AreaId"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据类型",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.companyInfo.DataType),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "DataType", $$v)
      },
      expression: "companyInfo.DataType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("测试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadOnly),
      expression: "isReadOnly"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.companyInfo.CustomerName) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属招商经理：",
      "label-width": "120px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.showData.LeasingManagerName) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属业务经理：",
      "label-width": "120px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.companyInfo.BusEmployeeName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companyInfo.SocialCreditCode !== ''),
      expression: "companyInfo.SocialCreditCode!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码：",
      "label-width": "140px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.companyInfo.SocialCreditCode) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companyInfo.Corporation !== ''),
      expression: "companyInfo.Corporation!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司法定代表人：",
      "label-width": "130px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.companyInfo.Corporation) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证：",
      "label-width": "100px"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Corporation_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业执照：",
      "label-width": "100px"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Company_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司地址："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.showData.ProvName) + " - " + _vm._s(_vm.showData.CityName) + " - " + _vm._s(_vm.showData.AreaName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showData.DataTypeName) + "\n            ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3afcb747!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/agent-base-infonew/index.vue
// module id = 1460
// module chunks = 1